const checkForEncryptedPdf = (file: File) => {
  return new Promise((resolve) => {
    if (file.type !== "application/pdf") {
      resolve(false);
    }

    const reader = new FileReader();
    const blob = file.slice(0, 1024);

    // This process is a more efficient than reading the entire PDF with PDF.js and determining
    // if it is encrypted. However, it is less accurate.
    // TODO: see insides of PDF.js encrypted check to see what it looks for or if there's a
    // method to do it efficiently instead of this custom solution.
    reader.onload = async function (e) {
      const content = e.target?.result as string;
      if (!content) return;

      // Convert the binary string to an ArrayBuffer
      const buffer = new ArrayBuffer(content.length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < content.length; i++) {
        view[i] = content.charCodeAt(i);
      }

      // Convert to string to search for the '/Encrypt' marker
      const pdfHeaderString = String.fromCharCode.apply(
        null,
        view as unknown as number[]
      );
      if (pdfHeaderString.includes("/Encrypt")) {
        // /Encrypt found — verify if a password is actually required.
        // Owner-only encryption (e.g. restrict printing/copying) uses an
        // empty user password and will load successfully.
        try {
          const bytes = await readFile(file);
          const { PDFDocument } = await import("@cantoo/pdf-lib");
          await PDFDocument.load(bytes, { password: "" });
          resolve(false);
        } catch {
          resolve(true);
        }
      } else {
        resolve(false);
      }
    };

    reader.readAsBinaryString(blob);
  });
};

// Example function to read a file using FileReader
async function readFile(file: File): Promise<Uint8Array> {
  return new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();

    // Set up the onload callback
    reader.onload = (event) => {
      if (event.target?.result instanceof ArrayBuffer) {
        // Resolve with the Uint8Array representation of the ArrayBuffer
        resolve(new Uint8Array(event.target.result));
      } else {
        reject(new Error("Failed to read file"));
      }
    };

    // Set up the onerror callback
    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    // Read the file as ArrayBuffer
    reader.readAsArrayBuffer(file);
  });
}

export { checkForEncryptedPdf, readFile };
